"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TitleCard = exports.ValidationErrorsTitleCard = void 0;
const react_1 = __importStar(require("react"));
const Card_1 = __importDefault(require("react-bootstrap/Card"));
const Form_1 = __importDefault(require("react-bootstrap/Form"));
const useDebouncedState_1 = require("../../../utils/useDebouncedState");
const IconVisibility_1 = require("../../icons/IconVisibility");
const IconVisibilityOff_1 = require("../../icons/IconVisibilityOff");
const ValidationErrors_1 = require("../../ValidationErrors");
class ValidationErrorsTitleCard extends ValidationErrors_1.ValidationErrors {
    constructor() {
        super(...arguments);
        this.titleInvalid = "";
    }
}
exports.ValidationErrorsTitleCard = ValidationErrorsTitleCard;
const TitleCard = (props) => {
    var _a;
    // Debounce changes to speed up editing experience.
    const [debouncedTitle, setDebouncedTitle] = (0, useDebouncedState_1.useDebouncedState)(props.booking.title, (title) => props.onBookingChange({ title }), 300, { leading: true });
    const [debouncedSubtitle, setDebouncedSubtitle] = (0, useDebouncedState_1.useDebouncedState)(props.booking.subtitle, (subtitle) => props.onBookingChange({ subtitle }), 300, { leading: true });
    const [validationErrors, setValidationErrors] = (0, react_1.useState)(new ValidationErrorsTitleCard());
    // Validate if data changes.
    (0, react_1.useEffect)(() => {
        const errors = new ValidationErrorsTitleCard();
        if (props.booking.title.trim() === "") {
            errors.titleInvalid = "Bitte Titel angeben";
        }
        setValidationErrors(errors);
        props.isInvalidChange(errors.hasErrors());
    }, [props.booking]);
    return (react_1.default.createElement(Card_1.default, { className: "title-card " + ((_a = props.className) !== null && _a !== void 0 ? _a : "") },
        react_1.default.createElement(Card_1.default.Body, null,
            react_1.default.createElement(Form_1.default.Group, { controlId: "booking-title" },
                react_1.default.createElement(Form_1.default.Label, { title: props.booking.publicDisplay
                        ? "Titel öffentlich sichtbar auf Display"
                        : "Titel nicht sichtbar auf Display" },
                    "Titel",
                    " ",
                    props.booking.publicDisplay ? (react_1.default.createElement(IconVisibility_1.IconVisibility, { className: "text-primary" })) : (react_1.default.createElement(IconVisibilityOff_1.IconVisibilityOff, null))),
                react_1.default.createElement(Form_1.default.Control, { className: "strong", type: "text", value: debouncedTitle, onChange: (e) => setDebouncedTitle(e.target.value.slice(0, 40)), isInvalid: validationErrors.titleInvalid !== "" }),
                react_1.default.createElement(Form_1.default.Control.Feedback, { type: "invalid" }, validationErrors.titleInvalid)),
            react_1.default.createElement(Form_1.default.Group, { controlId: "booking-subtitle" },
                react_1.default.createElement(Form_1.default.Label, { title: props.booking.publicDisplay
                        ? "Untertitel öffentlich sichtbar auf Display"
                        : "Untertitel nicht sichtbar auf Display" },
                    "Untertitel",
                    " ",
                    props.booking.publicDisplay ? (react_1.default.createElement(IconVisibility_1.IconVisibility, { className: "text-primary" })) : (react_1.default.createElement(IconVisibilityOff_1.IconVisibilityOff, null))),
                react_1.default.createElement(Form_1.default.Control, { className: "", type: "text", value: debouncedSubtitle, onChange: (e) => setDebouncedSubtitle(e.target.value.slice(0, 40)) })),
            react_1.default.createElement(Form_1.default.Group, { controlId: "booking-public-display", className: "mb-0 no-print" },
                react_1.default.createElement(Form_1.default.Check, { inline: true, type: "switch", label: "Auf Display anzeigen", checked: props.booking.publicDisplay, onChange: (e) => props.onBookingChange({ publicDisplay: e.target.checked }) })))));
};
exports.TitleCard = TitleCard;
